module.exports = __webpack_public_path__ + "static/media/designer.2a01dc3b.jpg";